function corrigirVirgulasJsonInvalido(jsonString) {
    console.log('corrigirVirgulasJsonInvalido', jsonString);
    if (typeof jsonString !== 'string') return jsonString; // não é string? devolve igual
    try {
        // Remove vírgulas antes de } ou ]
        return jsonString.replace(/,\s*([}\]])/g, '$1');
    } catch {
        return jsonString; // qualquer erro -> devolve igual
    }
}
export default corrigirVirgulasJsonInvalido;
